var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowDiagonalUp48Line = function SvgIconArrowDiagonalUp48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.22 13.78c-.56-.56-1.32-.9-2.12-.85l-14.68.36.08 3.4 11.7-.28-15.76 15.76 2.4 2.4L31.6 18.81l-.28 11.7 3.4.08.36-14.68c.02-.79-.29-1.56-.85-2.12l-.01-.01Z",
    fill: "current"
  })));
};
export default SvgIconArrowDiagonalUp48Line;